module.exports = __webpack_public_path__ + "img/avatar.afda9c2f.svg";